import { Spin, Table } from 'antd';
import { styled } from 'styled-components';
import LoadingError from '../../ui/error/LoadingError';
import { Excel } from 'antd-table-saveas-excel';
import DownloadButton from '../../ui/DownloadButton';

const PrimaryCdTable = (props) => {
  const { dataSource, isError, isLoading } = props;

  let nullColumns = [];
  if(dataSource.length) {
    nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
  }

  const columns = [
    {
      title: 'Deal Date',
      dataIndex: 'DealDate',
      key: 'DealDate',
      render: (_, { DealDate }) => DealDate && DealDate.split(' ')[0]
    },
    {
      title: 'Security',
      dataIndex: 'Security',
      key: 'Security',
    },
    {
      title: 'Maturity(months)',
      dataIndex: 'Maturity',
      key: 'Maturity',
    },
    {
      title: 'Quantum(Crs.)',
      dataIndex: 'Quantam',
      key: 'Quantam'
    },
    {
      title: 'Rate(%)',
      dataIndex: 'Rate',
      key: 'Rate',
    },
    {
      title: 'Buyer',
      dataIndex: 'Buyer',
      key: 'Buyer'
    },
    {
      title: 'Seller',
      dataIndex: 'Seller',
      key: 'Seller'
    },
    {
      title: 'Updated On',
      dataIndex: 'addedOn',
      key: 'addedOn',
      render: (_, { addedOn }) => addedOn && addedOn
    },
  ].filter((item) => !nullColumns.includes(item.key));

  function excelExportHandler() {
    const excel = new Excel();
    excel.addSheet("Sheet 1")
    .addColumns(columns)
    .addDataSource(dataSource, { str2Percent: true })
    .saveAs("PrimaryCd.xlsx");
  }

  if(isLoading) return (
    <Spin
        tip="Loading"
        size="large"
        className='loading-spiner'
    />
  );
  if(isError) return <LoadingError />;

  return (
      <Wrapper>
        <DownloadButton onClick={excelExportHandler}>Export</DownloadButton>
          <div className='card'>
              <Table 
              dataSource={dataSource}
              bordered
              size='medium'
              columns={columns} 
              style={{
                  marginTop: '10px',
                  padding: 0,
              }}
              />
          </div>
      </Wrapper>
  );
}

export default PrimaryCdTable;

const Wrapper = styled.div`
    /* width: 95%;
    margin: auto; */
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;



